var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewCourse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 7.5625C14.4375 8.47418 14.0753 9.34852 13.4307 9.99318C12.786 10.6378 11.9117 11 11 11C10.0883 11 9.21398 10.6378 8.56932 9.99318C7.92466 9.34852 7.5625 8.47418 7.5625 7.5625C7.5625 6.65082 7.92466 5.77648 8.56932 5.13182C9.21398 4.48716 10.0883 4.125 11 4.125C11.9117 4.125 12.786 4.48716 13.4307 5.13182C14.0753 5.77648 14.4375 6.65082 14.4375 7.5625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.5625C0 7.5625 4.125 0 11 0C17.875 0 22 7.5625 22 7.5625C22 7.5625 17.875 15.125 11 15.125C4.125 15.125 0 7.5625 0 7.5625ZM11 12.375C12.2764 12.375 13.5004 11.868 14.403 10.9655C15.3055 10.0629 15.8125 8.83885 15.8125 7.5625C15.8125 6.28615 15.3055 5.06207 14.403 4.15955C13.5004 3.25703 12.2764 2.75 11 2.75C9.72365 2.75 8.49957 3.25703 7.59705 4.15955C6.69453 5.06207 6.1875 6.28615 6.1875 7.5625C6.1875 8.83885 6.69453 10.0629 7.59705 10.9655C8.49957 11.868 9.72365 12.375 11 12.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewCourse);
export default __webpack_public_path__ + "static/media/view_course.e327c6cb1bcba0bba3d1f03a2f674f17.svg";
export { ForwardRef as ReactComponent };